import {
    MASTER_UNIT_ITEM,
    MASTER_UNIT_ITEM_FAILURE,
    MASTER_UNIT_ITEM_SUCCESS, MASTER_UNIT_WEIGHT, MASTER_UNIT_WEIGHT_FAILURE, MASTER_UNIT_WEIGHT_SUCCESS
} from "../../../constant/master/MasterUnitConstant";

const initialState = {
    masterWeightItem: {
        data: [],
        status: 'idle',
        isLoading: true,
    },
};

export const MasterWeightItemReducer = (state = initialState, action) => {
    const {type, payload} = action;
    switch (type) {
        case MASTER_UNIT_WEIGHT:
            return {
                ...state,
                masterWeightItem: {
                    data: [],
                    status: 'fetching',
                    isLoading: true,
                },
            };
        case MASTER_UNIT_WEIGHT_SUCCESS:
            return {
                ...state,
                masterWeightItem: {
                    data: payload,
                    status: 'ready',
                    isLoading: false,
                },
            };
        case MASTER_UNIT_WEIGHT_FAILURE:
            return {
                ...state,
                masterWeightItem: {
                    data: [],
                    status: 'fetching',
                },
            };
        default:
            return state;
    }
}
